(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ella-category-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  let previousOverflow;
  const getDrawer = () => document.getElementById('EllaCategoryDrawer');
  const showPanel = (drawer, id, focus) => {
    const panels = Array.from(drawer.querySelectorAll('.ella-drawer-panel'));
    const active = panels.find(panel => panel.id === id);
    if (!active) return;
    panels.forEach(panel => { panel.hidden = panel !== active; });
    drawer.querySelectorAll('[data-panel]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.panel === id)));
    drawer.querySelector('#EllaDrawerHeading').textContent = active.dataset.heading;
    const back = drawer.querySelector('.ella-drawer-back');
    back.hidden = !active.dataset.parent;
    back.dataset.panel = active.dataset.parent || '';
    drawer.querySelector('.ella-drawer-content').scrollTop = 0;
    if (focus) (back.hidden ? drawer.querySelector('.ella-drawer-close') : back).focus();
  };
  window.addEventListener('click', event => {
    const trigger = event.target.closest('.mobile-nav-trigger');
    const drawer = getDrawer();
    const cookieLink = event.target.closest('[data-ella-cookie-settings]');
    if (cookieLink) {
      const widget = document.querySelector('pandectes-cmp')?.shadowRoot?.querySelector('button.widget');
      if (widget) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (drawer && drawer.open) drawer.close();
        widget.click();
      }
      return;
    }

    if (trigger && drawer && window.matchMedia('(max-width:1199px)').matches) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (drawer.open) { drawer.close(); return; }
      opener = trigger;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', drawer.id);
      showPanel(drawer, 'ella-categories-root', false);
      drawer.showModal();
      return;
    }
    if (!drawer || !drawer.open) return;
    if (drawer.contains(event.target)) event.stopImmediatePropagation();
    if (event.target.closest('.ella-drawer-close')) { drawer.close(); return; }
    const panelButton = event.target.closest('[data-panel]');
    if (panelButton && drawer.contains(panelButton)) showPanel(drawer, panelButton.dataset.panel, true);
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
    }
  }, true);
  document.addEventListener('close', event => {
    if (event.target.id !== 'EllaCategoryDrawer') return;
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }, true);
  window.addEventListener('resize', () => {
    const drawer = getDrawer();
    if (drawer && drawer.open && window.innerWidth > 1199) drawer.close();
  });
})();

(() => {
  let attempts = 0;
  const setupCookieLinks = () => {
    const root = document.querySelector('pandectes-cmp')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('button.widget')) {
      const observer = new MutationObserver(() => {
        if (root.querySelector('button.widget')) {
          observer.disconnect();
          setupCookieLinks();
        }
      });
      observer.observe(root, { childList: true, subtree: true });
      return true;
    }
    const configure = link => {
      link.href = '#cookie-settings';
      link.textContent = 'Cookie-Einstellungen';
      link.setAttribute('data-ella-cookie-settings', '');
      link.setAttribute('aria-haspopup', 'dialog');
      link.style.fontFamily = 'Roboto,Arial,sans-serif';
    };
    document.querySelectorAll('a[href="/pages/cookies"]').forEach(configure);
    document.querySelectorAll('.ella-drawer-row[href="/pages/kontakt"], .slide-nav__link[href="/pages/kontakt"], .megamenu__col-title a[href="/pages/kontakt"]').forEach(contact => {
      const item = contact.parentElement;
      if (item.parentElement.querySelector('[data-ella-cookie-settings]')) return;
      const copy = item.cloneNode(true);
      configure(copy.querySelector('a'));
      item.after(copy);
    });
    const footerLink = document.querySelector('footer [data-ella-cookie-settings], .site-footer [data-ella-cookie-settings]');
    if (!footerLink) return false;
    if (!root.querySelector('#ella-cookie-position')) {
      const style = document.createElement('style');
      style.id = 'ella-cookie-position';
      style.textContent = 'button.widget{display:none!important}';
      root.appendChild(style);
    }
    return true;
  };
  if (!setupCookieLinks()) {
    const timer = setInterval(() => {
      attempts += 1;
      if (setupCookieLinks() || attempts >= 120) clearInterval(timer);
    }, 500);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
